import { tokens } from './tokens/ts/tokens.js';

function token(varName) {
    return `var(${varName})`;
}
function computedToken(varName) {
    return tokens[varName];
}

export { computedToken, token };
//# sourceMappingURL=jsTokens.js.map
